import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { DiscountsOverview } from '@/containers/supervizor/discounts/DiscountsOverview'
import { SidebarProvider } from '@/context/SidebarContext'
import { useAvailableProducts } from '@/hooks/useProducts'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'

export const DiscountsOverviewPage = () => {
  const products = useAvailableProducts()

  return (
    <SidebarProvider>
      <PageWrapper
        header={<DashboardHeader title="Přehled slev" />}
        sidebar={products.length > 1 ? <Sidebar /> : undefined}
        mainProps={{
          sx: {
            pt: { base: 0, md: 8 },
            gap: 6,
            display: 'grid',
          },
        }}
      >
        <DiscountsOverview />
      </PageWrapper>
    </SidebarProvider>
  )
}
